import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete2",
  "use": "icon-delete2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-delete2\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" d=\"M5 7.25h6v1.5H5z\" /><circle cx=\"8\" cy=\"8\" r=\"6.25\" stroke=\"currentColor\" stroke-width=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol